import styled from '@emotion/styled';
import { Box } from '@podiumhq/design-system';

const SelectPlanGhostStateCard = ({ isMobile, ...props }) => (
  <GhostState
    height={isMobile ? '230px' : '545px'}
    marginTop={isMobile ? '24px' : '72px'}
    width="360px"
    {...props}
  />
);

const GhostState = styled(Box)`
  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  animation: placeHolderShimmer 1.5s linear;
  animation-iteration-count: infinite;
  background-size: 200% auto;
  background: #f4f6f9;
  background: linear-gradient(to right, #f4f6f9 8%, #eeeeee 18%, #f4f6f9 33%);
  border-radius: 8px;
  margin: 4px 0;
`;

export default SelectPlanGhostStateCard;
